import { Platform } from 'react-native';

/**
 * E2E-only lever — the same mechanism as `FEATURE_FLAG_OVERRIDES` and
 * `E2E_DEVICE_FINGERPRINT_UNAVAILABLE`: an ungated storage hook the Cypress runner
 * writes before the page loads. It carries the backend's e2e skip keys; the API
 * client forwards them as `justsalad-secret-key` / `automated-test` / `X-E2E-Key`
 * headers — that is ALL the app does with them. The backend skips captcha
 * verification when it sees the key; the frontend runs the real hCaptcha widget
 * untouched. No build carries the keys and they are meaningless unless the backend
 * validates them, so a stray value in a real browser does nothing.
 */
const E2E_SKIP_KEYS_STORAGE_KEY = 'E2E_SKIP_KEYS';

export interface E2eSkipKeys {
    secretKey?: string;
    automatedTestKey?: string;
    e2eKey?: string;
}

export const readE2eSkipKeys = (): E2eSkipKeys | null => {
    if (Platform.OS !== 'web' || typeof window === 'undefined') {
        return null;
    }
    try {
        const raw = window.localStorage.getItem(E2E_SKIP_KEYS_STORAGE_KEY);
        if (!raw) {
            return null;
        }
        const parsed: unknown = JSON.parse(raw);
        return parsed && typeof parsed === 'object' ? (parsed as E2eSkipKeys) : null;
    } catch {
        return null;
    }
};
